import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@devhop/ui";

export type ConvertSalesOrderInvalidLine = {
  orderIndex: number;
  description: string;
  reason: string;
};

type ConvertQuotationToSalesOrderErrorDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invalidLines: ConvertSalesOrderInvalidLine[];
};

export function ConvertQuotationToSalesOrderErrorDialog({
  open,
  onOpenChange,
  invalidLines,
}: ConvertQuotationToSalesOrderErrorDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>ແປງເປັນຄຳສັ່ງຂາຍບໍ່ໄດ້</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground text-sm">
          ທຸກລາຍການຕ້ອງເລືອກຈາກ catalog (product) — ລາຍການຕໍ່ໄປນີ້ຍັງເປັນ free-text:
        </p>
        <ul className="max-h-60 space-y-2 overflow-y-auto text-sm">
          {invalidLines.map((line) => (
            <li
              key={`${line.orderIndex}-${line.description}`}
              className="rounded-md border px-3 py-2"
            >
              <span className="font-medium">#{line.orderIndex + 1}</span>{" "}
              {line.description || "—"}
            </li>
          ))}
        </ul>
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>
            ປິດ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
